import styled from "styled-components";


const Card = styled.div.attrs({
    className: "flex flex-col justify-between text-center my-36 mx-auto px-5 py-10 w-80  border rounded-lg h-[250px] bg-[#FFFFFF]"
  })``;
  
  const CardContent = styled.p.attrs({
    className: "mt-10 text-xl text-center",
  })``;
  
  const CardTitle = styled.p.attrs({
    className: "text-center text font-bold text-md mt-4 text-[#DF6865]",
  })``;
  
  const CardSpan = styled.p.attrs({
    className:"text-xs text-[#888888]",
  })``;
  const Header = styled.div.attrs({
    className:
      "bg-[#FFFFFF] h-24 flex justify-center items-center",
  })``;
  


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Card,
    CardContent,
    CardTitle,
    Header,
    CardSpan
  };
  